import { useState } from 'react';
import { ClipboardDocumentListIcon, TruckIcon, ShoppingCartIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import logo from "../assets/logoNA.svg";
import api from '../utils/api'

export default function Order() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [serviceDescription, setServiceDescription] = useState('');
    const [locationFrom, setLocationFrom] = useState('');
    const [locationTo, setLocationTo] = useState('');
    const [preferredTimings, setPreferredTimings] = useState('');

    const servicesList = [
        {
            id: 1,
            title: "Transfers and Courier Services",
            description: "Secure delivery of small goods, packages, materials or luggage transfers",
            icon: TruckIcon
        },
        {
            id: 2,
            title: "Daily Shopping",
            description: "Shop and Deliver groceries, medicines, dairy, raw chicken and other essentials",
            icon: ShoppingCartIcon
        },
        {
            id: 3,
            title: "Personal Tasks",
            description: "Package pickup, dry cleaning, postal services, document processing and more",
            icon: ClipboardDocumentListIcon
        }
    ];

    const handleServiceToggle = (serviceId) => {
        setSelectedServices(prev =>
            prev.includes(serviceId)
                ? prev.filter(id => id !== serviceId)
                : [...prev, serviceId]
        );
    };

    // Map selected service IDs to their title-description strings
    const serviceDetails = selectedServices.map(id => {
        const service = servicesList.find(s => s.id === id);
        return `${service.title} - ${service.description}`;
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const orderData = {
            namedValues: {
                Services: serviceDetails,
                Description: [serviceDescription],
                Name: [name],
                "Email Address": [email],
                "Phone Number": [phone],
                Address: [address],
                "Location From": [locationFrom],
                "Location To": [locationTo],
                Timings: [preferredTimings]
            }
        };

        try {
            const response = await api.post('/api/orders/sendOrder', orderData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            console.log('Order successful:', response?.data);
            alert('Order successful! Our agent will contact you soon')
            setName('')
            setEmail('')
            setAddress('')
            setPhone('')
            setLocationFrom('')
            setLocationTo('')
            setPreferredTimings('')
            setServiceDescription('')
            setSelectedServices([])
            window.location.reload()

        } catch (error) {
            console.error('Submission error:', error);
        }
    };

    const checksum = name && email && phone && address && serviceDescription && selectedServices[0]
    // console.log(name, phone, email, address, serviceDescription, serviceDetails, locationFrom, locationTo, preferredTimings)
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-sky-500 to-white">
            <nav className="fixed w-full bg-white/90 backdrop-blur-lg shadow-lg z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-20"> {/* Increased height */}
                        <div className="flex-shrink-0 flex items-center space-x-3">
                            <div className="relative w-16 h-16">
                                <img src={logo} alt='' />
                            </div>
                            <a href='/' className="text-3xl p-0 m-0 font-bold bg-gradient-to-r from-blue-900 to-sky-600 bg-clip-text text-transparent no-underline leading-tight pb-1">
                                NexusAgents
                            </a>
                        </div>

                        {/* Desktop Menu - Increased text size */}
                        <div className="hidden md:flex space-x-8">
                            <a href="services" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Services</a>
                            <a href="how" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">How It Works</a>
                            <a href="contact" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Contact</a>
                        </div>
                        {/* <a href="login" className="hidden md:flex bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a>
                        <a href="login" className="md:hidden bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a> */}

                        {/* Mobile Menu Button - Larger size */}
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="md:hidden p-3 rounded-lg text-blue-900 hover:bg-sky-50"
                        >
                            <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu - Larger text */}
                {isMenuOpen && (
                    <div className="md:hidden px-4 pt-2 pb-4 space-y-2">
                        <a href="services" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Services</a>
                        <a href="how" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">How It Works</a>
                        <a href="contact" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Contact</a>
                    </div>
                )}
            </nav>

            {/* Hero Section */}
            <div className="pt-32 px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
                        Order Now
                    </h1>
                    <p className="text-xl text-sky-100 mb-8 max-w-3xl mx-auto">
                        Fill the below form and Order Services or products
                    </p>
                    <h6 className='text-center text-xl text-sky-100 mb-12'>( Services available only in Prayagraj/Allahabad, Uttar Pradesh, India Right Now )</h6> 
                </div>
            </div>

            {/* Order Form Section */}
            <div className="py-16 bg-white/90 backdrop-blur-sm">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <form className="space-y-8" onSubmit={handleSubmit}>
                        {/* Personal Details Section */}
                        <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-blue-900 border-b-2 border-sky-500 pb-2">
                                Contact Information
                            </h2>

                            <div className="grid md:grid-cols-2 gap-6">
                                <div className="space-y-1">
                                    <label className="block text-lg font-medium text-blue-900">
                                        Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                    />
                                </div>

                                <div className="space-y-1">
                                    <label className="block text-lg font-medium text-blue-900">
                                        Email <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                    />
                                </div>

                                <div className="space-y-1">
                                    <label className="block text-lg font-medium text-blue-900">
                                        Phone Number <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="tel"
                                        required
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                    />
                                </div>

                                <div className="space-y-1">
                                    <label className="block text-lg font-medium text-blue-900">
                                        Address <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Services Selection */}
                        <div className="space-y-6">
                            <div className='mb-4'>
                                <h2 className="text-2xl font-bold text-blue-900">
                                    Service Type <span className="text-red-500">*</span>
                                </h2>
                                <h6 className="text-blue-800 border-b-2 border-sky-500 pb-4">
                                    ( Select 1 or more Service Types you want to order )
                                </h6>
                            </div>

                            <div className="grid gap-4">
                                {servicesList.map((service) => (
                                    <div
                                        key={service.id}
                                        className={`p-4 rounded-xl border-2 cursor-pointer transition-all ${selectedServices.includes(service.id)
                                            ? 'border-sky-600 bg-sky-50'
                                            : 'border-sky-100 hover:border-sky-300'
                                            }`}
                                        onClick={() => handleServiceToggle(service.id)}
                                    >
                                        <div className="flex items-start gap-4">
                                            <service.icon className="h-6 w-6 text-sky-600 mt-1" />
                                            <div>
                                                <h3 className="text-lg font-semibold text-blue-900">
                                                    {service.title}
                                                </h3>
                                                <p className="text-gray-600">
                                                    {service.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Additional Details */}
                        <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-blue-900 border-b-2 border-sky-500 pb-2">
                                Service Details
                            </h2>

                            <div className="space-y-4">
                                <div className="space-y-1">
                                    <label className="block text-lg font-medium text-blue-900">
                                        Service Description <span className="text-red-500">*</span>
                                        <h6 className="text-blue-800">
                                            ( Details of your requirements or deliveries or services you want  )
                                        </h6>
                                    </label>
                                    <textarea
                                        rows="4"
                                        required
                                        value={serviceDescription}
                                        onChange={(e) => setServiceDescription(e.target.value)}
                                        className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                    ></textarea>
                                </div>

                                <div className="grid md:grid-cols-1 gap-6">
                                    <div className="space-y-1">
                                        <label className="block text-lg font-medium text-blue-900">
                                            Location From (OPTIONAL - Applicable in case of Transfers & Courier Service)
                                            <h6 className="text-blue-800">
                                                ( From where you want our agent to pick things for transfer  )
                                            </h6>
                                        </label>
                                        <input
                                            type="text"
                                            value={locationFrom} onChange={(e) => setLocationFrom(e.target.value)}
                                            className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                        />
                                    </div>

                                    <div className="space-y-1">
                                        <label className="block text-lg font-medium text-blue-900">
                                            Location To
                                            <h6 className="text-blue-800">
                                                ( Where or at which place you want our agent to deliver , drop or transfer your packages, products or things )
                                            </h6>
                                        </label>
                                        <input
                                            type="text"
                                            value={locationTo} onChange={(e) => setLocationTo(e.target.value)}
                                            className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                        />
                                    </div>

                                    <div className="space-y-1">
                                        <label className="block text-lg font-medium text-blue-900">
                                            Preferred Timings
                                            <h6 className="text-blue-800">
                                                ( Give the time range around which you want services )
                                            </h6>
                                        </label>
                                        <input
                                            type="text"
                                            value={preferredTimings} onChange={(e) => setPreferredTimings(e.target.value)}
                                            className="w-full px-4 py-3 border border-sky-100 rounded-lg focus:ring-2 focus:ring-sky-500"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Submit Section */}
                        <div className="text-center space-y-5">
                            <button
                                type="submit"
                                disabled={!checksum}
                                className={`${checksum ? 'bg-gradient-to-r from-blue-900 to-sky-600 cursor-pointer' : 'bg-gradient-to-r from-blue-700 to-sky-300'}  text-white px-8 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity flex items-center gap-2 mx-auto`}
                            >
                                Submit Order
                                <ArrowRightIcon className="h-5 w-5 text-white" />
                            </button>
                            
                        </div>
                        {(!checksum) && <div className="text-red-500 my-3">* Please Fill all required Details *</div>}
                    </form>
                </div>
            </div>

            {/* Reused Footer from Services.js */}
            <footer className="bg-blue-900 text-sky-100 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p>Copyright © 2025 NexusAgents. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}